export default __webpack_public_path__ + "static/media/server2.d7085dd4.jpg";